<template>
  <section class="contact-info d-flex flex-column gap-2x gap-sm-16">
    <div class="d-flex flex-column flex-sm-row">
      <div class="contact-info-col d-flex flex-column mb-sm-0">
        <span class="contact-title text-xl mb-2">NUEVOS PROYECTOS</span>
        <a href="mailto:proyectos@grupomsh.com.ar" class="contact-text ct-big text-lg mb-0 mb-sm-2 ">proyectos@grupomsh.com.ar</a>
        <span class="contact-text ct-big text-lg mb-0 mb-sm-2  ">(054-11) 5263-0413 <strong class="ct-big">(ARG)</strong></span>
        <a href="http://wa.me/5491139512718" class="contact-text ct-big text-lg mb-0 mb-sm-2">(54 9 11) 3951-2718 <strong class="ct-big">(WHATSAPP)</strong></a>
        <!-- <span class="contact-text ct-big text-lg  ">+1 (424) 877-2485 <strong class="ct-big">(USA)</strong></span> -->
      </div>
      <div class="contact-info-col d-flex flex-column mb-2x mb-sm-0">
        <span class="contact-title text-xl mb-2 ">TRABAJA CON NOSOTROS</span>
        <a href="mailto:info@grupomsh.com.ar" class="contact-text ">info@grupomsh.com.ar</a>
        <span class="contact-title mb-2 mt-8 ">PRESS & MEDIA</span>
        <a href="mailto:info@grupomsh.com.ar" class="contact-text " >info@grupomsh.com.ar</a>
      </div>
      <div class="contact-info-col d-flex flex-column mb-2x mb-sm-0">
        <span class="contact-title text-lg mb-2 ">SOCIAL</span>
        <a href="https://www.linkedin.com/company/grupo-msh-s-a-/" target="_blank" class="contact-text mb-2 ">Linkedin</a>
        <a href="https://www.instagram.com/grupomshsa/" target="_blank" class="contact-text mb-2 ">Instagram MSH</a>
        <a href="https://www.instagram.com/msh_lab/" target="_blank" class="contact-text mb-2 ">Instagram MSH Lab</a>
        <!-- <a href="#" target="_blank" class="contact-text mb-2 ">Vimeo</a> -->
        <a href="https://www.youtube.com/@grupomsharquitecturametali7182" target="_blank" class="contact-text ">YouTube</a>
      </div>
    </div>
    <div class="map-container" v-if="isMobile">
      <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3288.951888096704!2d-58.6620524234225!3d-34.478744750910266!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95bca369df551489%3A0xdc135d82ba636953!2sGrupo%20MSH%20S.A.!5e0!3m2!1ses-419!2sar!4v1710115491776!5m2!1ses-419!2sar" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
    </div>
    <div class="contact-info-col contact-info-col-mobile d-flex flex-column">
      <span class="contact-title text-xl mb-2 ">PLANTA INDUSTRIAL</span>
      <span class="contact-text ">Rodriguez Peña 2598. El talar, Buenos Aires, Argentna</span>
      <span class="contact-text ct-big text-base sm:text-3xl mt-8 ">40.7108°N, 74.0095° W</span>
    </div>
  </section>
</template>

<script>
import { isMobile } from 'mobile-device-detect'
export default {
  data () {
    return {
      isMobile
    }
  }
}
</script>

<style lang="scss" scoped>
.contact-info {
  margin-top: 140px;
  gap: 4rem;
  .contact-info-col {
    flex: 1;
    .contact-title {
      color: $footer-text;
      font-weight: 700;
      strong {
        color: $footer-text;
        font-size: 2rem;
        font-weight: 700;
      }
    }
    .contact-text {
      color: #fff;
      font-size: 18px;
      line-height: 1.4;
    }
    .ct-big{
      font-size: 42px;
      line-height: 1.4;
    }
    strong.ct-big{
      color: $footer-text;
      font-weight: 700;
    }
    &:first-child {
      flex: 2;
    }
  }
}

.mt-8{
  margin-top: 2rem;
}
.mb-2x{
  margin-bottom: 20px;
}

.map-container {
    width: 100%;
    height: 200px;
    iframe {
      width: 100%;
      height: 100%;
    }
  }

@media (max-width: 768px) {
  .contact-info {
    gap: 20px;
    margin-top: 45px;
    .contact-info-col {
      margin-bottom: 35px;
      &.contact-info-col-mobile {
        margin-top: 40px !important;
      }
      .contact-title {
        font-size: 18px;
        line-height: 1.2;
        margin-bottom: 20px !important;
      }
      .contact-text {
        font-size: 18px;
        line-height: 1.2;
        margin-bottom: 15px !important;
      }
      .ct-big{
        font-size: 18px;
        line-height: 1.2;
      }
      }
    }
}
</style>
